/**
 * Maps data types to their base units
 * Based on Remoni.Domain.Entities.DataType2Set
 */

export const DATA_TYPE_UNITS = {
  power: 'W',
  'power-consumption': 'kWh',
  'accumulated-power': 'kWh',
  current: 'A',
  'accumulated-current': 'Ah',
  voltage: 'V',
  'grid-frequency': 'Hz',
  temperature: '°C',
  flow: 'm3/h',
  'flow-normalized': 'Nm3',
  'flow-consumption': 'm3',
  'flow-consumption-normalized': 'Nm3',
  'accumulated-flow': 'm3',
  'accumulated-flow-normalized': 'Nm3',
  heat: 'W',
  'heat-consumption': 'kWh',
  'accumulated-heat': 'kWh',
  'uncalibrated-current': null,
  'time-consumption': 'ms',
  'indicative-consumption': null,
  'standby-consumption': null,
  'apparent-power': 'VA',
  'sample-interval': 's',
  raw: null,
  'co2-concentration': 'ppm',
  humidity: '%',
  'analog-voltage': 'mV',
  'analog-current': 'μA',
  ph: 'pH',
  volume: 'm3',
  'mass-concentration': 'mg/L',
  'power-factor': 'Power Factor',
  weight: 'kg',
  quantity: null,
  percent: '%',
  custom: null,
  presence: null,
  'single-coil-current': 'A',
  'motor-frequency': 'Hz',
  'motor-frequency-score': null,
  unknown: null,
  'flow-speed': 'L/h',
  'uncalibrated-flow-speed': 'L/h',
  pressure: 'bar',
  Length: 'm',
  'Radon-level-Bq': 'Bq/m3',
  'Radon-level-pCi': 'pCi/l',
  voc: 'ppb',
  'uncalibrated-accumulated-flow': 'm3',
  'signal-amplitude': null,
};

/**
 * Get the base unit for a given data type
 * @param {string} dataType - The data type key
 * @returns {string|null} The base unit or null if not found or no unit
 */
export const getDataTypeUnit = (dataType) => {
  if (!dataType) {
    return null;
  }
  return DATA_TYPE_UNITS[dataType] ?? null;
};

/**
 * Check if a data type has a unit
 * @param {string} dataType - The data type key
 * @returns {boolean} True if the data type has a unit
 */
export const hasUnit = (dataType) => {
  const unit = getDataTypeUnit(dataType);
  return unit !== null && unit !== undefined;
};
